<template>
  <div
    class="tw-flex tw-h-full tw-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-border tw-border-solid tw-border-transparent tw-transition-colors tw-duration-150 tw-ease-in-out hover:tw-text-orange-500"
    :class="{ isSelected }"
  >
    {{ value }}
  </div>
</template>

<script setup lang="ts">
type Props = {
  value: number
  current: number
}

const props = defineProps<Props>()

const isSelected = computed<boolean>(() => props.value === props.current)
</script>

<style lang="scss" scoped>
.isSelected {
  @apply tw-rounded-xs tw-border-orange-500 tw-bg-orange-100 tw-font-medium tw-text-orange-500;
}
</style>
